import { render, staticRenderFns } from "./AnalyticsOrdersAndAvg.vue?vue&type=template&id=57502fb4"
import script from "./AnalyticsOrdersAndAvg.vue?vue&type=script&lang=js"
export * from "./AnalyticsOrdersAndAvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports